// Port of api/fuel/app/classes/controller/api/monty/app/help.php
import DB from 'offline/db'

function setting(name) {
	var rows = DB.query('SELECT setting_value FROM generic_settings WHERE setting_name = ? LIMIT 1', [name])
	return rows.length ? rows[0].setting_value : ''
}

export default function(params) {
	var questions = []
	var content = ''
	var key = 'help_' + (params.name || '')
	var data = setting(key)
	var parts = data.split('<p>###</p>')

	content = parts[0] || ''

	for (var i = 1; i < parts.length; i++) {
		var subparts = parts[i].split('<p>')
		questions.push({
			question: (subparts[1] || '').replace('</p>', ''),
			answer: '<p>' + subparts.slice(2).join('')
		})
	}

	return Promise.resolve({
		body: content,
		questions: questions
	})
}
